import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.categories');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-admin-categories',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.categories/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageAdminCategoriesComponent implements OnInit, OnDestroy {
    public ru = RU;
    public t: any = RU;
    public list: any[] = [];
    public loading: boolean = true;

    public showModal: boolean = false;
    public editing: any = null;
    public form: any = {};
    public saving: boolean = false;
    private langListener: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.t = getAdminT();
        this.langListener = async () => { this.t = getAdminT(); await this.service.render(); };
        window.addEventListener('admin-lang-change', this.langListener);
        await this.load();
    }

    ngOnDestroy() {
        if (this.langListener) window.removeEventListener('admin-lang-change', this.langListener);
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list");
        if (code === 200) {
            this.list = data || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public openCreate() {
        this.editing = null;
        this.form = {
            title_ru: '',
            title_ko: '',
            description_ru: '',
            icon: '📚',
            sort_order: this.list.length,
            status: 'active'
        };
        this.showModal = true;
        this.service.render();
    }

    public openEdit(item: any) {
        this.editing = item;
        this.form = {
            title_ru: item.title_ru || '',
            title_ko: item.title_ko || '',
            description_ru: item.description_ru || '',
            icon: item.icon || '📚',
            sort_order: item.sort_order || 0,
            status: item.status || 'active'
        };
        this.showModal = true;
        this.service.render();
    }

    public closeModal() {
        this.showModal = false;
        this.editing = null;
        this.service.render();
    }

    public async save() {
        if (!this.form.title_ru || !this.form.title_ko) {
            await this.service.modal.error("Заполните название категории (рус/кор) (카테고리 이름을 입력하세요)");
            return;
        }

        this.saving = true;
        await this.service.render();

        let res;
        if (this.editing) {
            res = await wiz.call("update", { id: this.editing.id, ...this.form });
        } else {
            res = await wiz.call("create", this.form);
        }

        this.saving = false;

        if (res.code === 200) {
            this.closeModal();
            await this.load();
        } else {
            await this.service.modal.error(res.data?.message || "Ошибка сохранения (저장 오류)");
            await this.service.render();
        }
    }

    public async delete(item: any) {
        const confirmed = await this.service.modal.show({
            title: 'Удалить категорию? (카테고리 삭제?)',
            message: `«${item.title_ru}» будет удалена. (삭제됩니다.)`,
            action: 'Удалить (삭제)',
            status: 'error'
        });
        if (!confirmed) return;

        const { code } = await wiz.call("delete", { id: item.id });
        if (code === 200) {
            await this.load();
        }
    }

    public async toggleStatus(item: any) {
        const newStatus = item.status === 'active' ? 'inactive' : 'active';
        await wiz.call("update", { id: item.id, status: newStatus });
        await this.load();
    }

    public async moveUp(index: number) {
        if (index <= 0) return;
        const arr = [...this.list];
        [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
        this.list = arr;
        await this.service.render();
        await this.saveOrder();
    }

    public async moveDown(index: number) {
        if (index >= this.list.length - 1) return;
        const arr = [...this.list];
        [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]];
        this.list = arr;
        await this.service.render();
        await this.saveOrder();
    }

    private async saveOrder() {
        const ids = this.list.map(c => c.id).join(',');
        await wiz.call("reorder", { ids });
    }
}

export default PageAdminCategoriesComponent;